module.exports = __webpack_public_path__ + "img/img_validation.0ceab2fa.png";